<template>
  <resource-box name="碳减排量">
    <div class="rectangle4-content" slot="content">
      <div class="rectangle4_body">
        <div class="rectangle4_body_title">
          <div class="rectangle4_body_title_name">碳减排量(万吨)</div>
          <digital-flipper
              :value="counterValue"
              color="#00eeff"
              class="rectangle4_body_title_nums"
              fontFamily="'Roboto', sans-serif"
              fontSize="36px"
          />
        </div>
      </div>
    </div>
  </resource-box>
</template>

<script>
import resourceBox from '@/views/IndustryMap/components/resourceBox.vue';
import DigitalFlipper from '@/components/DigitalFlipper/DigitalFlipper.vue';
export default {
  name: 'carbonEmission',
  components: {
    resourceBox,
    DigitalFlipper
  },
  props: {
    mapData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      counterValue: 0,
    };
  },
  watch: {
    mapData: {
      deep: true,
      handler: function (val) {
        if (val && val.c2Value) {
          this.counterValue = Number.isInteger(val.c2Value) ? val.c2Value : val.c2Value.toFixed(2);
        } else {
          this.counterValue = 0;
        }
      },
    },
  },
  methods: {
  },
  mounted() {
  }
};
</script>

<style lang="less" scoped>
.rectangle4-content {
  width: 100%;
  height: 100%;
  .rectangle4_body {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    background: url('~@/assets/recycling/echartsMap/carbonEmissions.png')
    no-repeat;
    background-size: 60%;
    background-position: center;
    .rectangle4_body_title {
      height: 100px;
      width: 100%;
      text-align: center;
      margin-top: 15px;
      .rectangle4_body_title_name {
        font-size: 16px;
        color: #ffffff;
      }
      .rectangle4_body_title_nums {
        color: #00eeff;
        height: 53px;
        font-weight: 700;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 36px;
      }
    }
  }
}
</style>
